
export class StakeholderHelper {
  positionInTheMineralSupplyChain;
  associatedMineSite;
  subCategory;
  category;
  globalBuyerPositions = ['internationalTrader', 'smelter', 'refiner', 'manufacture'];
  localTraderPosiotins = ['inCountryTrader', 'localTradingHouse'];
  miningOperatorPosiotins = ['miningOperator'];
  exporterPosiotins = ['exporter'];
  stakeholderSubCategoriesOptions = [];
  positionInMineralSupplyChainOptions = [];


  constructor(data, stkSubOptions = [], posOptions = []) {
    this.positionInTheMineralSupplyChain = data.positionInTheMineralSupplyChain;
    this.associatedMineSite = data.associatedMineSite;
    this.subCategory = data.subCategory;
    this.category = data.category;
    this.stakeholderSubCategoriesOptions = stkSubOptions;
    this.positionInMineralSupplyChainOptions = posOptions;
  }
  get isMiningOperator() {
    return (
      this.positionInTheMineralSupplyChain &&
      Array.isArray(this.positionInTheMineralSupplyChain) &&
      this.positionInTheMineralSupplyChain.filter((s) => this.miningOperatorPosiotins.includes(s)).length > 0
    ) || (
        this.associatedMineSite &&
        Array.isArray(this.associatedMineSite) &&
        this.associatedMineSite.filter(l => l.nature && l.nature.includes('operator')).length > 0
      ) ? true : false;
  }
  get isCooperative() {
    return (
      this.category === 'corporation' && this.subCategory === 'cooperative'
    ) ? true : false;
  }

  get isExporter() {
    return (
      this.positionInTheMineralSupplyChain &&
      Array.isArray(this.positionInTheMineralSupplyChain) &&
      this.positionInTheMineralSupplyChain.filter((s) => this.exporterPosiotins.includes(s)).length > 0 &&
      this.category === 'corporation'
    )  ? true : false;
  }
  get isGlobalBuyer() {
    return (
      this.positionInTheMineralSupplyChain &&
      Array.isArray(this.positionInTheMineralSupplyChain) &&
      this.positionInTheMineralSupplyChain.filter((s) => this.globalBuyerPositions.includes(s)).length > 0 &&
      this.category === 'corporation'
    ) ? true : false;
  }
  get isLocalTrade() {
    return (
      this.positionInTheMineralSupplyChain &&
      Array.isArray(this.positionInTheMineralSupplyChain) &&
      this.positionInTheMineralSupplyChain.filter((s) => this.localTraderPosiotins.includes(s)).length > 0
    ) || (
        !this.isMiningOperator &&
        this.subCategory === 'cooperative'
      ) ? true : false;
  }

  get undeterminedRole() {
    return !(
      this.isMiningOperator ||
      this.isExporter ||
      this.isLocalTrade ||
      this.isGlobalBuyer
    ) ? true : false;
  }
  getSubCategoryTitle() {
    const option = this.stakeholderSubCategoriesOptions.find(o => o.value === this.subCategory);
    if (option) {
      return option.label;
    }
    return '';
  }
  getGlobalBuyerTitle() {
    if (this.isGlobalBuyer) {
      for (const p of this.positionInTheMineralSupplyChain) {
        const option = this.positionInMineralSupplyChainOptions.find(o => o.value === p);
        if (option) {
          return option.label;
        }
      }
    }
    return '';
  }
  getLocalTraderTitle() {
    if (this.subCategory === 'cooperative') {
      const option = this.stakeholderSubCategoriesOptions.find(o => o.value === 'cooperative');
      if (option) {
        return option.label;
      }
      return 'Cooperative';
    }
    for (const p of this.positionInTheMineralSupplyChain) {
      const option = this.positionInMineralSupplyChainOptions.find(o => o.value === p);
      if (option) {
        return option.label;
      }
    }
    return '';
  }

  getMiningOperator(result, withSubcategory = false) {
    const label = this.positionInMineralSupplyChainOptions.find(p => p.value === 'miningOperator');
    result.title = label && label ? label.label : 'Mining Operator';
    result.type = 'miningOperator';
    result.color = '#1B262C';
    result.namespace = 'scp';
    return result;
  }

  getExporter(result, withSubcategory = false) {
    const label = this.positionInMineralSupplyChainOptions.find(p => p.value === 'exporter');
    result.title = `${label && label ? label.label : 'Exporter'}`;
    result.type = 'exporter';
    result.color = '#24A19C';
    result.namespace = 'scp';
    return result;
  }

  getLocalTrader(result) {
    result.title = this.getLocalTraderTitle();
    result.type = 'localTrader';
    result.color = '#0F4C75';
    result.namespace = 'scp';
    return result;
  }

  getGlobalBuyer(result) {
    result.title = this.getGlobalBuyerTitle();
    result.type = 'globalBuyer';
    result.color = '#FADB14';
    result.namespace = 'scp';
    return result;
  }

  getUndeterminedRole(result) {
    const title = {
      en: 'Undetermined Role',
      fr: 'Undetermined role',
    };
    result.title = title || title.en;
    result.type = 'undetermined';
    result.color = 'Red';
    result.namespace = 'scp';
    return result;
  }
  getResult(scp) {
    let result = {
      name: scp.name,
      parent: scp.parent,
      id: scp.id,
      datastakeId: scp.datastakeId,
      title: 'International trader',
      type: 'globalBuyer',
      color: '#FADB14',
      namespace: 'scp',
      sources: scp.sources,
      children: [],
      parents: [],
    };
    if (
      this.isMiningOperator ||
      this.isExporter ||
      this.isLocalTrade ||
      this.isGlobalBuyer
    ) {
      if (this.isMiningOperator) {
        result = this.getMiningOperator(result, false);
      } else if (this.isExporter) {
        result = this.getExporter(result, false);
      } else if (this.isLocalTrade) {
        result = this.getLocalTrader(result);
      } else if (this.isGlobalBuyer) {
        result = this.getGlobalBuyer(result);
      }
    } else {
      result = this.getUndeterminedRole(result);
    }
    return result;
  }
}
